<app-loader [Parent]="this"></app-loader>

<app-pageheader [Parent]="this">
</app-pageheader>

@if (SelectedLot != null) {
  <app-levelviewer #levelviewercomponent [parkingLotId]="SelectedLot['Id']" [AllowSelection]="true" (DeviceClicked)="DeviceClicked($event)"
    [parkingLevelId]="SelectedLevel['Id']" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;" >
  </app-levelviewer>
}

@if (SelectedLot != null) {
  <div class="columns" style="position:absolute; bottom: 30px; width:100%; left:10px;" [ngStyle]="{'pointer-events': PauseSelecting ? 'none' : 'auto', 'cursor': PauseSelecting ? 'not-allowed' : 'default'}">
    <div class="column is-4" style="background-color: #727171; height: 8em;" >
      <div class="columns">
        <div class="column is-12">
          <div class="select">
            @if (ParkingLots != null && ParkingLots.length >= 1) {
              <select class="input" style="background-color:#363535; color:white; border:none; text-transform: uppercase; text-align: left;" (change)="ParkingLotChanged($event)">
                @for (pl of ParkingLots; track pl; let i = $index) {
                  <option [value]="pl.Id" [selected]="SelectedLot != null && SelectedLot['Id'] == pl.Id">{{pl.Name}}</option>
                }
              </select>
            }
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <div class="container">
            <div class="select" style="width:60%">
              @if (SelectedLot.Levels != null && SelectedLot.Levels.length >= 1) {
                <select class="input" style="background-color:#363535; color:white; border:none; text-transform: uppercase;" (change)="ParkingLevelChanged($event)">
                  @for (pl of SelectedLot.Levels; track pl; let i = $index) {
                    <option [value]="pl.Id" [selected]="SelectedLevel != null && SelectedLevel['Id'] == pl.Id">{{pl.Name}}</option>
                  }
                </select>
              }
            </div>
            <div class="select" style="padding-left:10px;">
              <select class="input" style="background-color:#363535; color:white; border:none; text-transform: uppercase;" (change)="onSelectChange($event)">
                <option disabled selected value="">Actions</option>
                <option value="edit">Edit Level Counts</option>
                <option value="close">Close Level</option>
                <option value="open">Open Level</option>
              </select>
            </div>
            <div style="padding-left:10px;">
              <div class="mediabutton" (click)="ToggleSound()">
                <div style="color:white; margin:10px;"><i class="fa fa-solid" [ngClass]="SoundEnabled ? 'fa-volume-up' : 'fa-volume-off'"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-4" style="height: 8em; background-color: #363535; border-style: solid 1px white;" >
      @if (SelectedLot != null) {
        <div class="lotTitle" #lotTitle>
          <div class="occupancyTitle">OCCUPANCY</div>
          <div class="occupancy">{{SelectedLot.OccupiedSpaces}} / {{SelectedLot.TotalSpaces}}</div>
          @if (SelectedLot != null) {
            <div class="operatorconsoleheat">
              <app-heatmap class="heatmap" TopLabel="New" [width]="250" BottomLabel="4 Hours +" >
              </app-heatmap>
            </div>
          }
        </div>
      }
    </div>
    <div class="column is-4" style="background-color: #727171; height: 8em;" >
      @if (SelectedLot != null) {
        <div class="propertiestab">
          <div class="select objects">
            <button class="input" style="background-color:#363535; color:white; border:none; text-transform: uppercase; padding: 20px; max-width: 100%" (click)="ToggleBox()"> {{SelectedDevice != null ? SelectedDevice.DevicePath : 'Select Device'}}
            </button>
          </div>
          @if (SelectedDevice != null && SelectedDevice.ClassName == 'Barrier') {
            <div style="margin:10px;">
              <button type="button" class="button is-small operatorconsole" (click)="OpenBarrier(SelectedDevice.Id)">Open</button>
              <button type="button" class="button is-small operatorconsole" (click)="CloseBarrier(SelectedDevice.Id)">Close</button>
              <button type="button" class="button is-small operatorconsole" (click)="KeepBarrierOpen(SelectedDevice.Id)">Keep Open</button>
            </div>
          }
        </div>
      }
      @if (SelectedLot != null) {
        <div class="box" [ngStyle]="{ 'display': boxVisible ?  'block' : 'none' }">
          <div class="hid-box" [ngStyle]="{ 'top': boxVisible ?  '0px' : '100%' }">
            @if (SelectedLevel != null) {
              <aside class="menu">
                <p class="menu-label">
                  {{SelectedLevel.Name}}
                </p>
                <ul class="menu-list objects">
                  @for (gate of SelectedLevel.Gates; track gate) {
                    <li><a>{{gate.Name}}</a>
                    <ul>
                      @for (lane of gate.Lanes; track lane) {
                        <li><a>{{lane.Name}}<span class="select is-small" (change)="ChangeLaneDirection(lane.Id, $event)"><select [disabled]="lane.AllowedDirections != 'Both'">
                          @if (lane.AllowedDirections == 'Entry' || lane.AllowedDirections == 'Both') {
                            <option [selected]="lane.CurrentDirection == 'Entry'"> Entry </option>
                          }
                          @if (lane.AllowedDirections == 'Exit' || lane.AllowedDirections == 'Both') {
                            <option [selected]="lane.CurrentDirection == 'Exit'"> Exit </option>
                          }
                        </select></span></a>
                        <ul>
                          @for (barrier of lane.Barriers; track barrier) {
                            <li (click)="DeviceClicked(barrier)"><a>Barrier: {{barrier.display}}</a></li>
                          }
                          @for (camera of lane.Cameras; track camera) {
                            <li (click)="DeviceClicked(camera)"><a>Camera: {{camera.LocalAddress}}:{{camera.LocalPort}}</a></li>
                          }
                          @for (cellrouter of lane.CellRouters; track cellrouter) {
                            <li (click)="DeviceClicked(cellrouter)"><a>Cell Router: {{cellrouter.Name}}</a></li>
                          }
                          @for (display of lane.Displays; track display) {
                            <li (click)="DeviceClicked(display)"><a>Display: {{display.LocalAddress}}:{{display.LocalPort}}</a></li>
                          }
                          @for (paymentTerminal of lane.PaymentTerminals; track paymentTerminal) {
                            <li (click)="DeviceClicked(paymentTerminal)"><a>Payment Terminal: {{paymentTerminal.LocalAddress}}:{{paymentTerminal.LocalPort}}</a></li>
                          }
                          @if (lane.LocalControllerId != null) {
                            <li>
                              @for (controller of SelectedLevel.Controllers; track controller) {
                                <ul>
                                  @if (controller.Id == lane.LocalControllerId) {
                                    <li (click)="DeviceClicked(controller)"><a>Local Controller: {{controller.Name}}</a></li>
                                  }
                                </ul>
                              }
                            </li>
                          }
                        </ul>
                      </li>
                    }
                  </ul>
                </li>
              }
            </ul>
          </aside>
        }
      </div>
    </div>
  }
</div>
</div>
}

@if (SelectedLot != null) {
  <div class="console" id="console">
    @for (ci of ConsoleLines; track ci) {
      <p>&gt; {{ci}}</p>
    }
  </div>
}